function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "delivery/truck");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 82.5667247,
  height: 183.842599
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L87.675445,0 C100.31172,4.78418128e-15 110.555445,10.2437249 110.555445,22.88 L110.555445,88.3023506 L110.555445,88.3023506 L0,88.3023506 L0,0 Z",
  id: "path-3"
}), /*#__PURE__*/React.createElement("filter", {
  x: "0.0%",
  y: "0.0%",
  width: "100.0%",
  height: "100.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-5"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0,
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  x: "0.0%",
  y: "0.0%",
  width: "100.0%",
  height: "100.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-6"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0,
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-7",
  x: 218.312018,
  y: 0,
  width: 39.1842084,
  height: 114.358782
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-9",
  points: "18.1926682 76.7217145 44.7819524 76.7217145 44.7819524 114.358782 18.1926682 114.358782"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-11",
  points: "43.3825164 0 110.555445 0 110.555445 62.2459193 43.3825164 62.2459193"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "delivery/truck",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(26.000000, 95.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M284,430 C402.741812,430 499,333.741813 499,215 C499,96.2581875 402.741812,0 284,0 C165.258187,0 69,96.2581875 69,215 C69,333.741813 165.258187,430 284,430",
  id: "Illo",
  fill: "#B9D5E0"
}), /*#__PURE__*/React.createElement("g", {
  id: "Truck-Copy",
  transform: "translate(0.000000, 164.246512)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(0.153611, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-2",
  fill: "#E6E6E6",
  points: "36.3853363 0 151.139089 0 151.139089 204.108712 36.3853363 204.108712"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(51.779132, 20.266113)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle-2",
  fill: "#D1D1D1",
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-2-Copy",
  fill: "#F8F8F8",
  points: "149.739653 0 379.247159 0 379.247159 204.108712 149.739653 204.108712"
}), /*#__PURE__*/React.createElement("path", {
  d: "M397.439828,20.2661133 L504.783993,20.2661133 C522.015277,20.2661133 535.983993,34.2348291 535.983993,51.4661133 L535.983993,204.108712 L535.983993,204.108712 L397.439828,204.108712 L397.439828,20.2661133 Z",
  id: "Rectangle-2-Copy-10",
  fill: "#F8F8F8"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Triangle",
  fill: "#F8F8F8",
  points: "535.284275 104.225725 552.777225 140.415213 517.791325 140.415213"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-3",
  fill: "#F2F2F2",
  x: 397.439828,
  y: 140.415213,
  width: 155.337397,
  height: 63.6934988
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#009B4F",
  cx: 298.287476,
  cy: 108.568464,
  rx: 44.9895581,
  ry: 31.8467494
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-9",
  fill: "#009B4F",
  x: 379.247159,
  y: 204.108712,
  width: 183.326118,
  height: 20.2661133,
  rx: 10.1330566
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#009B4F",
  cx: 229.715112,
  cy: 108.568464,
  rx: 44.9895581,
  ry: 31.8467494
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(411.434188, 34.741908)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle-2-Copy-10",
  fill: "#B5E6E5",
  xlinkHref: "#path-3"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-3",
  fill: "#FFFFFF",
  opacity: 0.277693563,
  mask: "url(#mask-4)",
  points: "-0.751650202 -1.5861174 103.055298 -1.5861174 -2.09642075 90.0079216"
})), /*#__PURE__*/React.createElement("path", {
  d: "M263.949489,88.3034847 C270.592262,93.7349013 274.598285,100.763072 274.598285,108.439424 C274.598285,116.115776 270.592262,123.143946 263.949489,128.575362 C257.304344,123.144652 253.297918,116.116161 253.297918,108.439424 C253.297918,100.865732 257.197508,93.9230004 263.68162,88.5222512 Z",
  id: "Combined-Shape",
  fill: "#00693C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.9206489,204.108712 L153.600957,204.108712 C159.197289,204.108712 163.734013,208.645436 163.734013,214.241769 C163.734013,219.838101 159.197289,224.374825 153.600957,224.374825 L40.9206489,224.374825 C35.3243163,224.374825 30.7875923,219.838101 30.7875923,214.241769 C30.7875923,208.645436 35.3243163,204.108712 40.9206489,204.108712 Z",
  id: "Rectangle-2-Copy-3",
  fill: "#00693C"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-2",
  fill: "#009B4F",
  x: 149.739653,
  y: 204.108712,
  width: 229.507506,
  height: 20.2661133
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-4",
  fill: "#172737",
  opacity: 0.200000003,
  filter: "url(#filter-5)",
  cx: 281.286639,
  cy: 262.735683,
  rx: 281.286639,
  ry: 6.51410783
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-4",
  fill: "#D1D4D7",
  filter: "url(#filter-6)",
  cx: 281.286639,
  cy: 262.735683,
  rx: 281.286639,
  ry: 6.51410783
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-4",
  fill: "#00693C",
  x: 379.247159,
  y: 204.108712,
  width: 18.1926682,
  height: 20.2661133
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-8",
  fill: "#E6E6E6",
  x: 379.247159,
  y: 20.2661133,
  width: 18.1926682,
  height: 183.842599
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-6",
  fill: "#CE7406",
  x: 36.3853363,
  y: 170.814383,
  width: 15.3937961,
  height: 24.6088518
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-7",
  fill: "#CE7406",
  x: 134.345857,
  y: 170.814383,
  width: 15.3937961,
  height: 24.6088518
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-5",
  fill: "#F08604",
  x: 149.739653,
  y: 170.814383,
  width: 18.1926682,
  height: 24.6088518
}), /*#__PURE__*/React.createElement("path", {
  d: "M531.785685,170.814383 L553.496097,170.814383 C554.644849,170.814383 555.576097,171.745631 555.576097,172.894383 L555.576097,189.000496 C555.576097,190.149249 554.644849,191.080496 553.496097,191.080496 L531.785685,191.080496 L531.785685,191.080496 L531.785685,170.814383 Z",
  id: "Rectangle-2-Copy-11",
  fill: "#F08604"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.943954,224.37465 C161.278563,244.745355 141.572093,260.564605 117.657584,260.564605 C93.7430748,260.564605 74.0366043,244.745355 71.3712137,224.37465 Z",
  id: "Combined-Shape-Copy-5",
  fill: "#01301C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M411.644128,224.37465 C408.978738,244.745355 389.272267,260.564605 365.357758,260.564605 C341.443249,260.564605 321.736779,244.745355 319.071388,224.37465 Z",
  id: "Combined-Shape-Copy-6",
  fill: "#01301C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.943951,224.37465 C161.681491,244.745355 144.954079,260.564605 124.654764,260.564605 C104.355449,260.564605 87.6280366,244.745355 85.3655773,224.37465 Z",
  id: "Combined-Shape-Copy-4",
  fill: "#003D23"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528.986873,169.430254 C525.803846,200.35775 502.269222,224.375117 473.70909,224.375117 C445.148958,224.375117 421.614334,200.35775 418.431307,169.430254 Z",
  id: "Combined-Shape-Copy-8",
  fill: "#003D23",
  transform: "translate(473.709090, 196.902980) scale(1, -1) translate(-473.709090, -196.902980) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M411.644125,224.37465 C409.381665,244.745355 392.654253,260.564605 372.354938,260.564605 C352.055623,260.564605 335.328211,244.745355 333.065751,224.37465 Z",
  id: "Combined-Shape-Copy-7",
  fill: "#003D23"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-2-Copy-2",
  fill: "#014B2B",
  cx: 473.114331,
  cy: 220.140656,
  rx: 44.8869112,
  ry: 40.6407961
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-2-Copy",
  fill: "#00693C",
  cx: 478.712075,
  cy: 220.140656,
  rx: 39.2891671,
  ry: 40.6407961
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-2-Copy",
  fill: "#FFFFFF",
  cx: 479.306834,
  cy: 220.755877,
  rx: 20.2918222,
  ry: 20.989903
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-2-Copy",
  fill: "#000000",
  cx: 479.306834,
  cy: 220.755877,
  rx: 4.89802604,
  ry: 5.06652831
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-6",
  fill: "#4199B6",
  opacity: 0.342583955,
  x: 411.434188,
  y: 91.1975096,
  width: 110.555445,
  height: 31.8467494
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-4-Copy",
  transform: "translate(19.745715, 166.471645)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-5-Copy",
  fill: "#B28D5F",
  points: "193.12217 0 219.711454 0 219.711454 114.358782 193.12217 114.358782"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-5-Copy-2",
  fill: "#B28D5F",
  points: "0 76.7217145 19.5921042 76.7217145 19.5921042 114.358782 0 114.358782"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-8",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-7"
})), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle-5",
  fill: "#D7AE7C",
  xlinkHref: "#path-7"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-10",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-9"
})), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle-5-Copy-3",
  fill: "#D7AE7C",
  xlinkHref: "#path-9"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(119.105672, 218.584507)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5-Copy",
  fill: "#B28D5F",
  x: 0,
  y: 0,
  width: 44.7819524,
  height: 62.2459193
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-12",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-11"
})), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle-5",
  fill: "#D7AE7C",
  xlinkHref: "#path-11"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-5",
  fill: "#A78151",
  opacity: 0.339785448,
  mask: "url(#mask-12)",
  points: "112.699015 -2.04484743 40.6629093 64.8293681 40.6629093 -8.66285868"
})))));

var SvgTruck = function SvgTruck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "620px",
    height: "620px",
    viewBox: "0 0 620 620",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTruck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/truck.b27da877.svg";
export { ForwardRef as ReactComponent };